document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.embla');

  sliders.forEach((slider) => {
    const viewport = slider.querySelector('.embla__viewport');

    const prevBtn = slider.querySelector('.prev');
    const nextBtn = slider.querySelector('.next');

    const dotsContainer = slider.querySelector('.slider-dots');

    const embla = EmblaCarousel(viewport, {
      loop: true,
      align: 'start',
      dragFree: false
    });

    /* -------------------- */
    /* Recalculate after images load */
    /* -------------------- */

    const images = slider.querySelectorAll('img');

    let imagesLoaded = 0;

    const onImageLoad = () => {
      imagesLoaded++;

      if (imagesLoaded >= images.length) {
        embla.reInit();
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        onImageLoad();
      } else {
        img.addEventListener('load', onImageLoad);
      }
    });

    /* -------------------- */
    /* Arrows */
    /* -------------------- */

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        embla.scrollPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        embla.scrollNext();
      });
    }

    /* -------------------- */
    /* Dots */
    /* -------------------- */

    if (dotsContainer) {
      const dots = embla.scrollSnapList();

      dots.forEach((_, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.classList.add('slider-dot');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);

        const isActive = index === embla.selectedScrollSnap();
        if (isActive) {
          dot.classList.add('active');
        }
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');

        dot.addEventListener('click', () => {
          embla.scrollTo(index);
        });

        dotsContainer.appendChild(dot);
      });

      const updateDots = () => {
        const allDots =
          dotsContainer.querySelectorAll('.slider-dot');

        allDots.forEach((dot, index) => {
          const isActive = index === embla.selectedScrollSnap();
          dot.classList.toggle('active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      embla.on('select', updateDots);

      updateDots();
    }


    window.addEventListener('resize', () => {
      embla.reInit();
    });
  });
});